import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "shadow rounded-lg flex flex-col bg-white h-full w-full" }
const _hoisted_2 = { class: "pb-4" }
const _hoisted_3 = { class: "flex bg-purple flex-col px-4 h-[70%] overflow-auto" }
const _hoisted_4 = { class: "table-auto w-full text-left" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = {
  key: 0,
  class: "w-[5px] right-0 top-1 z-10 py-2 cursor-pointer border-b pr-2"
}
const _hoisted_7 = { class: "flex flex-row items-center" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "right-0 top-0 bg-white z-10 border-b"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "text-center items-center justify-center pr-2 py-2"
}
const _hoisted_12 = { class: "flex flex-row items-center" }
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 1,
  class: "top-0 mt-2 right-0 flex items-center justify-center z-10 py-1"
}
const _hoisted_15 = {
  key: 1,
  class: "flex bg-white w-full rounded-md button-container"
}
const _hoisted_16 = {
  key: 2,
  class: "flex gap-4 w-full h-[3rem] py-1"
}
const _hoisted_17 = { colspan: "10" }
const _hoisted_18 = {
  colspan: "10",
  scope: "col",
  class: "py-1"
}

import { ref, computed, PropType, watch } from "vue";

import { formatNumber } from "@/services/utils";

import PaginationControl from "../atoms/PaginationControl.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewTableComponent',
  props: {
  isSelectable: {
    type: Boolean,
    default: false,
  },
  items: {
    type: Array as PropType<any>,
    required: true,
  },
  columns: {
    type: Array as PropType<any>,
    required: true,
  },
  buttons: {
    type: Array as PropType<any>,
    required: true,
  },
  showButtons: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "Tabla Por Defecto",
  },
  sectionAddButton: {
    type: String,
    default: "",
  },
  searchTableData: {
    type: Array as PropType<any>,
    required: false,
  },
  perPage: {
    type: Number,
    default: 50,
  },
  gap: {
    type: Number,
    default: 1,
  },
  isSelectPage: {
    type: Boolean,
    default: true,
    required: false,
  },
  rightHeaders: {
    type: Array,
    required: false,
    default: () => [],
  },
  centerHeaders: {
    type: Array,
    required: false,
    default: () => [],
  },
  boldHeaders: {
    type: Array,
    required: false,
    default: () => [],
  },
},
  emits: [
  "onItemSelected",
  "closeAction",
  "sortBy",
  "update:selected",
],
  setup(__props, { emit }) {

const props = __props;




const searchText = ref<string>("");
const currentPage = ref<number>(1);
const matches = ref<boolean>(true);
const perPageSelect = ref(props.perPage);
const showFirstPages = computed(() => currentPage.value <= 10);
const showLastPages = computed(() => currentPage.value > totalPages.value - 10);
const selectedRow = ref(null);
const selectAll = ref(false);
const selectedRows = ref([]);

const toggleAll = () => {
  selectedRows.value = selectAll.value
    ? props.items.map((item: any) => item.id)
    : [];
  emit("update:selected", selectedRows.value);
};

const updateSelected = () => {
  emit("update:selected", selectedRows.value);
};

const visiblePages = computed(() => {
  if (showFirstPages.value) {
    return Array.from(
      { length: Math.min(30, totalPages.value) },
      (_, index) => index + 1
    );
  } else if (showLastPages.value) {
    return Array.from(
      { length: Math.min(30, totalPages.value) },
      (_, index) => totalPages.value - 30 + index
    );
  } else {
    return Array.from(
      { length: 30 },
      (_, index) => currentPage.value - 5 + index
    );
  }
});
const resetParams = () => {
  matches.value = true;
};

const filteredItems = computed(() => {
  const start = (currentPage.value - 1) * perPageSelect.value;
  const end = start + perPageSelect.value;
  let totalMatches = 0;
  if (searchText.value === "") {
    resetParams();
    return props.items.slice(start, end);
  } else {
    console.table(props.items);
    return props.items
      .filter((item: Record<string, string>) => {
        return Object.keys(item).some((key: string) => {
          if (props.searchTableData.includes(key)) {
            const value = item[key] ? item[key].toLowerCase() : "";
            const match = value.includes(searchText.value.toLowerCase());
            if (match) {
              resetParams();
              totalMatches++;
              if (totalMatches <= perPageSelect.value) matches.value = false;
            }
            return value.includes(searchText.value.toLowerCase());
          }
          return false;
        });
      })
      .slice(start, end);
  }
});

const totalPages = computed(() =>
  Math.ceil(props.items.length / perPageSelect.value)
);
const goToPage = (page: number) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
  }
};
const previousPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
  }
};
const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
  }
};
const lastPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value = totalPages.value;
  }
};
const firstPage = () => {
  currentPage.value = 1;
};

watch(selectedRows, (newVal) => {
  selectAll.value = newVal.length === props.items.length;
});

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "filter"),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _createElementVNode("thead", _hoisted_5, [
              _createElementVNode("tr", null, [
                (__props.isSelectable)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectAll).value = $event)),
                          onChange: toggleAll,
                          class: "w-4 h-5 text-primary-green bg-gray-100 border-gray-300 rounded focus:ring-primary-green dark:focus:ring-primary-green dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        }, null, 544), [
                          [_vModelCheckbox, selectAll.value]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: column.id,
                    onClick: ($event: any) => (_ctx.$emit('sortBy', column.name)),
                    class: _normalizeClass(["right-0 top-0 z-10 bg-white w-max lg:px-2 py-2 cursor-pointer border-b", {
                    'text-right': __props.rightHeaders.includes(column.name),
                    'text-center': __props.centerHeaders.includes(column.name),
                  }])
                  }, _toDisplayString(column.label ?? "-"), 11, _hoisted_8))
                }), 128)),
                (__props.showButtons)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_9, " Acciones "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredItems.value, (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.id
                }, [
                  _createElementVNode("tr", {
                    class: _normalizeClass(["cursor-pointer items-center hover:bg-primary-green/20 py-1", {
                    'bg-blue-200': item === selectedRow.value + ` h-[${__props.gap}rem]`,
                  }]),
                    onClick: ($event: any) => (_ctx.$emit('onItemSelected', item))
                  }, [
                    (__props.isSelectable)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: item.id,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedRows).value = $event)),
                              onChange: updateSelected,
                              class: "w-4 h-5 text-primary-green bg-gray-100 border-gray-300 rounded focus:ring-primary-green dark:focus:ring-primary-green dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                            }, null, 40, _hoisted_13), [
                              [_vModelCheckbox, selectedRows.value]
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: column.id,
                        class: _normalizeClass(["py-1 px-8 lg:py-0 lg:px-2", {
                      'text-right': __props.rightHeaders.includes(column.name),
                      'text-center': __props.centerHeaders.includes(column.name),
                      'font-bold text-gray-700': __props.boldHeaders.includes(
                        column.name
                      ),
                    }])
                      }, _toDisplayString((typeof item[column.name] != "number"
                        ? item[column.name]
                        : _unref(formatNumber)(item[column.name])) ?? "-"), 3))
                    }), 128)),
                    (__props.showButtons)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                          (item.userRoleWorkers && item.userRoleWorkers != 3)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.buttons, (button) => {
                                return (_openBlock(), _createBlock(_component_mdicon, {
                                  class: _normalizeClass(["z-10", [
                          'mr-2 cursor-pointer px-2 py-1 rounded-md z-10',
                          button.className,
                        ]]),
                                  name: button.iconName,
                                  key: button.id,
                                  onClick: _withModifiers(($event: any) => (button.action(item)), ["stop"])
                                }, null, 8, ["name", "class", "onClick"]))
                              }), 128))
                            : _createCommentVNode("", true),
                          (!item.userRoleWorkers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.buttons, (button) => {
                                  return (_openBlock(), _createBlock(_component_mdicon, {
                                    name: button.iconName,
                                    key: button.id,
                                    class: _normalizeClass([
                            'mr-1 ml-1 cursor-pointer px-1 py-1 rounded-md z-20',
                            button.className,
                          ]),
                                    onClick: _withModifiers(($event: any) => (button.action(item)), ["stop"])
                                  }, null, 8, ["name", "class", "onClick"]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (__props.showButtons)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                          _renderSlot(_ctx.$slots, "actions", { item: item })
                        ]))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_10),
                  _createElementVNode("tr", _hoisted_17, [
                    _createElementVNode("td", _hoisted_18, [
                      _renderSlot(_ctx.$slots, "viewdata", { item: item })
                    ])
                  ])
                ], 64))
              }), 128))
            ])
          ]),
          (matches.value)
            ? (_openBlock(), _createBlock(PaginationControl, {
                key: 0,
                "selected-page": currentPage.value,
                "per-page": 10,
                "total-pages": totalPages.value,
                onSetPage: _cache[2] || (_cache[2] = (page) => (currentPage.value = page))
              }, null, 8, ["selected-page", "total-pages"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})